import { helloLab } from '@brightlocal/labs-hello';
import type { LabManifest } from '@brightlocal/labs-sdk';
import { websitePerformanceLab } from '@brightlocal/labs-website-performance';

// Hello is a placeholder with no real content, so it is registered in the `local` and `dev`
// environments only — where the Feature Mocker runs (see main.tsx). It is also the smoke test
// for the Labs shell and what the auth/me mocks switch on. Gated on VITE_ENV, not
// `import.meta.env.DEV`, which is false in the deployed `dev` previews (production builds).
// VITE_ENV is replaced at build time and compared with literals rather than ENVIRONMENTS,
// whose module validates the env on import, so for `stg`/`at`/`prod` this is `false` and Hello
// is left out of the bundle. Every other lab ships to every environment behind its flags.
const isDevBuild = import.meta.env.VITE_ENV === 'local' || import.meta.env.VITE_ENV === 'dev';

/** Every lab the host knows about. A new lab is its library plus one entry here. */
export const LABS: readonly LabManifest[] = isDevBuild ? [websitePerformanceLab, helloLab] : [websitePerformanceLab];

/** Finds a registered lab by its manifest id. */
export const findLab = (labId: string) => LABS.find((lab) => lab.id === labId);
